<template lang="html">
  <component
    :is="headlineTag"
    :class="[
      `headline--size-${size}`,
      { 'headline--center': center },
      { 'headline--desktop-fluid': desktopFluid },
      `headline--color-${color}`,
      { 'headline--underline': underlined }
    ]"
    class="headline"
  >
    <span
      class="headline__text"
    >
      <slot />
    </span>
  </component>
</template>

<script>
export default {
  props: {
    level: {
      type: Number,
      default: 2,
      validator (value) {
        return value >= 1 && value <= 6
      }
    },
    color: {
      type: String,
      default: () => ''
    },
    size: {
      type: [String, Number],
      default: 3,
      validator (value) {
        const val = Number(value)
        return val >= 1 && val <= 4
      }
    },
    center: {
      type: Boolean,
      default: () => false
    },
    underlined: {
      type: Boolean,
      default: () => false
    },
    desktopFluid: {
      type: Boolean,
      default: () => false
    },
    jsonPath: {
      type: String,
      default: () => ''
    }
  },
  computed: {
    headlineTag () {
      return `h${this.level || 2}`
    }
  }
}
</script>

<style lang="scss">
@import 'beisheim/scss/colors';
@import 'beisheim/scss/fluid-type';
@import 'beisheim/scss/font';
@import 'beisheim/scss/line-heights';
@import 'beisheim/scss/scale';
@import 'beisheim/scss/breakpoints';

.headline {
  margin-bottom: scale(4);
  line-height: line-height(2);

  strong {
    font-weight: bold;
  }

  a {
    border-bottom: 1px solid gray(1);
  }
}

@for $i from 1 through 4 {
  .headline--size-#{$i} {
    @include font($i - 1);

    @include from(4) {
      @include font($i);
    }
  }
}

.headline {
  &--size-1 {
    @include font(0.5);

    @include from(4) {
      @include font(1);
    }
  }
}

.headline--desktop-fluid {
  @include from(4) {
    @include fluid-type(18px, 52px, 1.4);
  }
}

.headline--underline {
  display: inline-block;
  .headline__text {
    border-bottom: 1px solid gray(1);
  }
}

.headline--center {
  text-align: center;
}

.headline--color-black {
  .headline__text {
    color: gray(1);
    border-bottom-color: gray(1);
  }
}

.headline--color-white {
  .headline__text {
    color: gray(5);
    border-bottom-color: gray(5);
  }
}
</style>
